import React from 'react';
import { Link } from 'react-router-dom';
import { FaCamera, FaUsers, FaSearchPlus, FaChartLine } from 'react-icons/fa';

function LandingPage({ user }) {
  return (
    <div className="landing-page">
      <div className="landing-hero">
        <h1>📸 Welcome to PhotoMatch</h1>
        <p>AI-Powered Photo Discovery Platform</p>
        <p>Find yourself in event photos automatically using facial recognition</p>
        
        {!user && (
          <div className="hero-buttons">
            <Link to="/register" className="btn-primary">
              Get Started Free
            </Link>
            <Link to="/login" className="btn-secondary">
              Sign In
            </Link>
          </div>
        )}
        
        {user && (
          <div className="hero-buttons">
            <Link to="/dashboard" className="btn-primary">
              Go to Dashboard
            </Link>
          </div>
        )}
      </div>

      <div className="features-section">
        <h2>How PhotoMatch Works</h2>
        
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <FaUsers />
            </div>
            <h3>1. Upload Your Photo</h3>
            <p>
              Create your profile and upload a clear photo of yourself. 
              Our AI will learn your facial features for accurate matching.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaCamera />
            </div>
            <h3>2. Photographers Upload Events</h3>
            <p>
              Professional photographers create events (weddings, birthdays, corporate) 
              and upload client photos to the platform.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaSearchPlus />
            </div>
            <h3>3. AI Finds Your Photos</h3>
            <p>
              Our facial recognition technology automatically matches you with 
              photos you appear in across all events.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaChartLine />
            </div>
            <h3>4. View & Analyze</h3>
            <p>
              Browse your matched photos organized by event, view confidence scores, 
              and track your photo discoveries over time.
            </p>
          </div>
        </div>
      </div>

      <div className="features-section">
        <h2>Perfect For</h2>
        
        <div className="features-grid">
          <div className="feature-card">
            <h3>🎉 Event Attendees</h3>
            <p>
              Never miss a photo of yourself at weddings, parties, or corporate events. 
              PhotoMatch finds all your photos automatically.
            </p>
          </div>

          <div className="feature-card">
            <h3>📷 Professional Photographers</h3>
            <p>
              Streamline photo delivery to clients. Upload event photos once, 
              and let clients discover their photos automatically.
            </p>
          </div>

          <div className="feature-card">
            <h3>🏢 Event Organizers</h3>
            <p>
              Enhance attendee experience by making it easy for everyone to find 
              and access their event photos in one place.
            </p>
          </div>
        </div>
      </div>

      <div className="features-section" style={{ textAlign: 'center', padding: '3rem 2rem' }}>
        <h2>Ready to Get Started?</h2>
        <p style={{ fontSize: '1.2rem', color: '#757575', marginBottom: '2rem' }}>
          Join PhotoMatch today and never miss a photo of yourself again!
        </p>
        {!user && (
          <Link to="/register" className="btn-primary" style={{ fontSize: '1.2rem', padding: '1.2rem 2.5rem' }}>
            Create Free Account
          </Link>
        )}
      </div>
    </div>
  );
}

export default LandingPage;
